"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.Root = exports.LinkList = exports.LinkIcon = exports.LinkBoxInner = exports.LinkBox = exports.DownloadIcon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        textAlign: 'center',
        justifySelf: 'center',
        [theme.breakpoints.up('md')]: {
            margin: '0 auto',
            gap: theme.spacing(6),
            maxWidth: 900
        }
    };
});
const LinkList = exports.LinkList = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(4),
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            maxWidth: 900,
            gap: theme.spacing(3)
        }
    };
});
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(()=>({
        display: '-webkit-box',
        overflow: 'hidden',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        '&:empty': {
            display: 'none'
        }
    }));
const LinkBoxInner = exports.LinkBoxInner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(2),
        textAlign: 'left',
        alignItems: 'center'
    };
});
const LinkBox = exports.LinkBox = (0, _mui.styled)(_mui.Link)((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        maxWidth: 'unset',
        padding: theme.spacing(3),
        border: "1px solid ".concat(theme.palette.grey[500]),
        borderRadius: theme.spacing(1),
        background: theme.palette.common.white,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-start',
        height: 70,
        textDecoration: 'none',
        '&:hover': {
            background: theme.palette.grey[200],
            color: theme.palette.text.primary
        },
        '&:active, &:focus': {
            color: theme.palette.text.primary
        },
        [theme.breakpoints.up('md')]: {
            width: 290
        }
    };
});
const DownloadIcon = exports.DownloadIcon = (0, _mui.styled)(_icons.Download)(()=>({
        width: 24,
        height: 24
    }));
const LinkIcon = exports.LinkIcon = (0, _mui.styled)(_icons.CopyLink)(()=>({
        width: 24,
        height: 24
    }));
